console.info('[DrawerSpy] Asset geladen');

document.addEventListener(
  'click',
  (ev) => {
    /* Ziel auf <a> heben */
    const tgt  = ev.target.nodeType === 3 ? ev.target.parentElement : ev.target;
    const link = tgt.closest?.('a[href]');
    if (!link) return;

    /* Same-page-Anchor? */
    const u       = new URL(link.getAttribute('href'), location.href);
    const same    = u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
    const anchor  = u.hash.length > 1;
    if (!(same && anchor)) return;

    /* 20 ms warten, damit der Browser scrollt, dann Drawer per Theme-Hook schließen */
    setTimeout(() => {
      const closeBtn = document.querySelector(
        '#sidebar-menu [data-action="close-drawer"][data-drawer-id="sidebar-menu"]'
      );
      if (closeBtn) {
        console.debug('[DrawerSpy] Close-Button gefunden – click() wird ausgelöst');
        closeBtn.click();         // 👉 löst Theme-eigene Schließroutine aus
      } else {
        console.warn('[DrawerSpy] Close-Button NICHT gefunden – Drawer bleibt offen');
      }
    }, 20);
  },
  true // capture = true
);
